import React, { useEffect, useState } from 'react';
import PaymentMethod from '../../checkout/payment-method/PaymentMethod';
import BillingDetails from '../../checkout/billing-details/BillingDetails';
import OrderSummary from '../../checkout/order-summary/OrderSummary';
import Loader from '../../../../components/loader/Loader';
import { auth } from '../../../../helper/firebase.helper';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { getOrgCode } from '../../../../helper/utils.helper';
import { getSelfAssessment, initSelfAssessment } from '../../../../helper/api.helper';
import { useStoreState } from 'easy-peasy';
import { administration_types } from '../../../../helper/constants.helper';

const SelfAssessmentCheckout = () => {
  const { assessmentSlug } = useParams();
  const navigate = useNavigate();
  const user = useStoreState((state) => state.user);

  const [billingDetails, setBillingDetails] = useState({
    paymentMethod: 1,
    name: '',
    email: auth?.currentUser?.email || '',
    street1: '',
    street2: '',
    city: '',
    state: '',
    country: '',
    postalCode: ''
  });
  const [assessment, setAssessment] = useState({});
  const [mobile, setMobile] = useState(auth?.currentUser?.phoneNumber || '');
  const [isLoading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    setLoading(true);
    const orgCode = getOrgCode();
    getSelfAssessment(orgCode, assessmentSlug)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === 'success') {
          if (res.assessmentUrl) {
            setShowComponent(false);
            window.location.href = res.assessmentUrl;
            return;
          }
          setShowComponent(true);
          setAssessment(res.data.assessment);
          if (res?.data?.client?.address) {
            setBillingDetails((prev) => ({
              ...prev,
              name: res?.data?.client?.name || '',
              street1: res?.data?.client?.address?.street1 || '',
              street2: res?.data?.client?.address?.street2 || '',
              city: res?.data?.client?.address?.city || '',
              state: res?.data?.client?.address?.state || '',
              country: res?.data?.client?.address?.country || '',
              postalCode: res?.data?.client?.address?.postalCode || ''
            }));
            setMobile(res.data?.client?.mobile);
          }
          if (res?.data?.paymentTypes) {
            setPaymentMethods(res?.data?.paymentTypes);
          }
        } else {
          setShowComponent(true);
          toast.error(res.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        setShowComponent(true);
        setLoading(false);
        toast.error(err.message);
      });
  }, []);

  const handleChange = (field, value) => {
    setBillingDetails((prev) => ({ ...prev, [field]: value }));
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'postalCode' && value.length > 6) {
      toast.error('Postal code should be of 6 numbers');
      return;
    }
    handleChange(name, value);
  };

  const openRazorpay = (order_id) => {
    const options = {
      // eslint-disable-next-line no-undef
      key: process.env.REACT_APP_RZP_API_KEY,
      order_id: order_id,
      handler: function () {
        toast.success('Assessment booked successfully');
        navigate(`/assessments/${assessmentSlug}/checkout/payment-successful`);
      },
      prefill: {
        name: billingDetails.name,
        email: billingDetails.email,
        contact: mobile
      },
      theme: {
        color: '#3399cc'
      }
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.on('payment.failed', function (response) {
      // alert(response.error.code);
      toast.error(`Payment failed: ${response.error.description}.`);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
    });
    rzp1.open();
  };

  const initAssessment = async (assessmentId) => {
    setLoading(true);
    if (user) {
      const orgCode = getOrgCode();
      await initSelfAssessment(orgCode, assessmentId, {
        name: billingDetails.name,
        mobile:
          mobile && mobile !== '91' && mobile.startsWith('+')
            ? mobile
            : mobile && mobile !== '91' && !mobile.startsWith('+')
              ? `+${mobile}`
              : null,
        address: {
          street1: billingDetails.street1,
          street2: billingDetails.street2,
          city: billingDetails.city,
          state: billingDetails.state,
          country: billingDetails.country,
          postalCode: billingDetails.postalCode
        }
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          if (res.status === 'success') {
            if (res?.orderId) {
              openRazorpay(res.orderId);
              setLoading(false);
            } else {
              setLoading(false);
              toast.success('Assessment booked successfully');
              window.location.href = res.assessmentUrl;
              //    navigate(`/assessments/${assessmentId}/checkout/payment-successful`);
            }
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.message);
        });
    } else {
      setLoading(false);
      toast.error('Please login to access assessments');
      navigate('/login');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (billingDetails.postalCode.length !== 6) {
      toast.error('Postal code should be of 6 numbers');
      return;
    }
    if (!billingDetails.city) {
      toast.error('Please select city.');
      return;
    }
    // if (mobile?.length !== 12) {
    //   toast.error('Mobile no. should be of 10 numbers');
    //   return;
    // }
    initAssessment(assessment.id);
  };

  return (
    <div className="checkout-wrapper flex-container">
      {isLoading ? (
        <Loader />
      ) : (
        showComponent && (
          <>
            <div className="fields-wrapper flex-container ">
              <div className="fields-container flex-container direction-column">
                {Number(assessment?.price) === 0 ? null : (
                  <PaymentMethod
                    billingDetails={billingDetails}
                    paymentMethods={paymentMethods}
                    handleInputChange={handleInputChange}
                  />
                )}
                <BillingDetails
                  handleSubmit={handleSubmit}
                  handleInputChange={handleInputChange}
                  billingDetails={billingDetails}
                  mobile={mobile}
                  setMobile={setMobile}
                  setBillingDetails={setBillingDetails}
                />
              </div>
            </div>
            <OrderSummary
              price={assessment?.price}
              title={assessment?.short_title}
              eligibility={assessment?.eligibility}
              duration={assessment?.duration}
              administrations={assessment?.administrations
                ?.map((administration) => administration_types[administration])
                .filter(Boolean)
                .join(', ')}
              shareReport={assessment?.shareReport}
            />
          </>
        )
      )}
      <style jsx>{`
        .checkout-wrapper {
          margin: auto;
          max-width: 1000px;
          min-height: 87vh;
          padding: 20px;
        }
        .fields-wrapper {
          width: 70%;
        }
        .fields-container {
          max-width: 500px;
        }

        @media only screen and (max-width: 800px) {
          .checkout-wrapper {
            flex-direction: column;
            align-items: center;
          }
          .fields-wrapper {
            justify-content: center;
            margin-top: 20px;
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default SelfAssessmentCheckout;
